window.addEventListener('load', function () {

  document.querySelectorAll('[data-quantity-input]').forEach(input => {
    input.addEventListener('input', () => {
      const max = parseInt(input.getAttribute('max'), 10);
      let val = parseInt(input.value, 10);

      if (val > max) {
        input.value = max; // Force max value
      } else if (val < 1) {
        input.value = 1; // Ensure minimum of 1
      }
    });
  });

  let readMoreItem = document.querySelector(".readmore-plp");
  if (readMoreItem) {
    readMoreItem.addEventListener("click", (e) => {
      e.preventDefault();
      var descriptionFull = document.querySelector(
        ".collection-description-full"
      );
      descriptionFull.style.display = "block";
      var descriptionShort = document.querySelector(
        ".collection-description-short"
      );
      descriptionShort.style.display = "none";
    });
  }
  let readLessItem = document.querySelector(".readless-plp");
  if (readLessItem) {
    readLessItem.addEventListener("click", (e) => {
      e.preventDefault();
      var descriptionFull = document.querySelector(
        ".collection-description-full"
      );
      descriptionFull.style.display = "none";
      var descriptionShort = document.querySelector(
        ".collection-description-short"
      );
      descriptionShort.style.display = "block";
    });
  }


  function findZone() {
    var jsonUrl = "https://cdn.shopify.com/s/files/1/0249/4994/8471/files/USA_Main_Zipcode.json.json?v=1732105324";
    var findYourZone = document.querySelectorAll('.find-your-zone-home');
    var zonePopup = document.getElementById('zonePopup');
    var zoneOverlay = document.getElementById('zoneOverlay');
    var closeZonePopup = document.getElementById('closeZonePopup');
    var submitZone = document.getElementById('submitZone');
    var errorMessage = document.getElementById('errorMessage');
    var zones = [];

    // Cookie helpers
    function setCookie(name, value, days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
    }

    function getCookie(name) {
      var cookies = document.cookie.split('; ');
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        if (parts[0] === name) {
          return parts[1];
        }
      }
      return null;
    }

    // Fetch JSON data
    var xhr = new XMLHttpRequest();
    xhr.open("GET", jsonUrl, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var data = JSON.parse(xhr.responseText);
            zones = data.Main;
          } catch (e) {
            console.error("Error parsing JSON:", e);
          }
        } else {
          console.error("Failed to fetch JSON data");
        }
      }
    };
    xhr.send();

    // Display saved zone if exists
    function displaySavedZone() {
      var savedZone = getCookie('hardinessZone');
      if (savedZone) {
        findYourZone.forEach(function (element) {
          element.textContent = savedZone;
          element.style.color = "#4f7e53";
        });
      }
    }

    displaySavedZone();

    // Open popup
    for (var i = 0; i < findYourZone.length; i++) {
      findYourZone[i].addEventListener('click', function () {
        zonePopup.style.display = 'block';
        zoneOverlay.style.display = 'block';
      });
    }

    // Close popup
    closeZonePopup.addEventListener('click', function () {
      zonePopup.style.display = 'none';
      zoneOverlay.style.display = 'none';
    });

    zoneOverlay.addEventListener('click', function () {
      zonePopup.style.display = 'none';
      zoneOverlay.style.display = 'none';
    });

    // Submit zone
    submitZone.addEventListener('click', function () {
      var zipcodeInput = document.getElementById('zipcodeInput');
      var zipcode = zipcodeInput.value.trim();
      var zipcodeRegex = /^[0-9]{5,6}$/;

      var matchingZone = null;
      for (var i = 0; i < zones.length; i++) {
        if (zones[i].zipcode === parseInt(zipcode)) {
          matchingZone = zones[i];
          break;
        }
      }

      if (matchingZone && zipcodeRegex.test(zipcode)) {
        var resultText = "My Zone: " + matchingZone.zone + " - " + zipcode;

        for (var j = 0; j < findYourZone.length; j++) {
          findYourZone[j].textContent = resultText;
          findYourZone[j].style.color = "#4f7e53";
        }

        setCookie('hardinessZone', resultText, 7);
        zonePopup.style.display = 'none';
        zoneOverlay.style.display = 'none';
        errorMessage.style.display = 'none';
      } else {
        errorMessage.style.display = 'block';
        errorMessage.textContent = 'Invalid zip code. Please try again.';
      }
    });
  }

  findZone();
});

simply.getCookie = function (cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};
simply.setCookie = function (cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

class Preorder {
  constructor(parent, model) {
    if (!cn(parent)) {
      this.preorderJson = JSON.parse(parent[0].innerHTML);
    } else {
      this.preorderJson = JSON.parse(
        document.querySelector(".preorderJson").innerHTML
      );
    }
    this.apiResponse = [];
    this.selectedVariant = simply.selectedVariantId;
    this.addToCartBtn = document.querySelector("[data-product-atc]");
    this.soldOutBtn = document.querySelector(".sold-out-btn");
    this.preOrderBtn = document.querySelector(".preorder-btn");
    this.notifyMeBtn = document.querySelector(".notify-btn");
    this.leftQty = document.querySelector(".preorder-qty-left");
    this.qtyInput = document.querySelector(".quantity-selector__input");
    if (model) {
      this.addToCartBtn = model[0].querySelector("[data-product-atc]");
      this.preOrderBtn = model[0].querySelector('.preorder-btn');
      this.notifyMeBtn = model[0].querySelector(".notify-btn");
      this.leftQty = model[0].querySelector(".preorder-qty-left");
      this.qtyInput = model[0].querySelector(".quantity-selector__input");
    }
    this.appApi = "https://raintreepreorder.lucentinnovation.com/";
    this.init();
  }
  preOrderDetails = () => {
    let variantDetails = this.preorderJson.variants;
    let outOfstock = [];
    for (let i = 0; i < variantDetails.length; i++) {
      if (variantDetails[i].inventory_qty <= 0) {
        outOfstock.push({
          id: variantDetails[i].id,
          inventory_policy: variantDetails[i].inventory_policy,
        });
      }
    }
    this.preorderStockCheck(outOfstock);
  };
  preorderStockCheck = (outOfstock) => {
    let preorderStock = { variant_ids: outOfstock };
    let url =
      this.appApi + "product/stock/check?shop=raintreenursery.myshopify.com";
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(preorderStock),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 200) {
          this.apiResponse.push(data.data);
          this.variantChange(this.selectedVariant);
        }
      });
  };
  preOrderPopUp = () => {
    let modal = document.querySelector("#myModal");
    let btn = document.querySelector(".notify-btn");
    let span = document.querySelector(".preorder-modal .close");
    let header = document.querySelector(".site-header");
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      modal.classList.add("active");
      header.classList.add("active");
    });
    span.addEventListener("click", () => {
      modal.classList.remove("active");
      header.classList.remove("active");
    });
    window.addEventListener("click", (event) => {
      if (event.target == modal) {
        modal.classList.remove("active");
        header.classList.remove("active");
      }
    });
    this.notifyEmail();
  };
  notifyEmail = () => {
    let notifyForm = document.querySelector(".preorder-modal .custom_form");
    let submitButton = notifyForm.querySelector(".subscribe-btn");
    if (submitButton) {
      submitButton.removeAttribute("disabled");
      submitButton.addEventListener("click", (e) => {
        e.preventDefault();
        let emailEle = notifyForm.querySelector('input[type="email"]');
        let erroeMsg = document.querySelector(".email-error-msg");
        let obj = { variant_id: this.selectedVariant, email: emailEle.value };
        let url =
          this.appApi + "email/notify?shop=raintreenursery.myshopify.com";
        if (!this.validateEmail(emailEle.value)) {
          flag = 0;
          notifyForm["email_id"].value = "";
          notifyForm["email_id"].focus();
          erroeMsg.classList.remove("hidden");
        } else {
          erroeMsg.classList.add("hidden");
          fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(obj),
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.status == 200) {
                document.querySelector(".notify-msg").classList.add("active");
                submitButton.setAttribute("disabled", disabled);
                setTimeout(() => {
                  document
                    .querySelector(".notify-msg")
                    .classList.remove("active");
                  document.querySelector("#myModal").classList.remove("active");
                }, 5000);
              }
            });
        }
      });
    }
  };
  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
  hideAllButton = () => {
    this.addToCartBtn.classList.add("hidden");
    this.soldOutBtn.classList.add("hidden");
    this.preOrderBtn.classList.add("hidden");
    this.notifyMeBtn.classList.add("hidden");
    this.leftQty.classList.add("hidden");
  };
  showSoldOut = (showNotify) => {
    this.soldOutBtn.classList.remove("hidden");
    if (showNotify) {
      this.notifyMeBtn.classList.remove("hidden");
    }
  };
  variantChange = (variant) => {
    let variantId;
    if (variant) {
      if (typeof variant == "number") {
        variantId = variant;
      } else {
        variantId = variant.id;
      }
      this.selectedVariant = variantId;
      let apiRes = this.apiResponse;
      let flag = true;
      if (apiRes.length > 0 && apiRes[0].length > 0) {
        apiRes[0].map((item) => {
          if (item.is_enable) {
            if (item.variant_id == variantId) {
              flag = false;
              if (item.is_enable && item.quantity > 0) {
                if (Number(this.qtyInput.value) > item.quantity) {
                  this.hideAllButton();
                  this.showSoldOut(item.notify_me);
                } else {
                  this.hideAllButton();
                  this.preOrderBtn.classList.remove("hidden");
                  this.leftQty.classList.remove("hidden");
                  this.leftQty.innerText =
                    "Only " + item.quantity + " Left in Stock! Order Now!";
                  simply.item = item;
                  this.qtyInput.setAttribute('max', item.quantity);
                }
              } else {
                this.hideAllButton();
                this.showSoldOut(item.notify_me);
              }
            }
          }
        });
        simply.setCookie('item-selected', JSON.stringify(simply.item));
        // this.addPreorder(simply.item);
      }
      if (flag) {
        this.hideAllButton();
        this.addToCartBtn.classList.remove("hidden");
      }
    }
  };

  addPreorder = () => {
    if (this.preOrderBtn) {
      this.preOrderBtn.addEventListener("click", (e) => {
        let item = JSON.parse(simply.getCookie('item-selected'));
        if (this.qtyInput.value > item.quantity) {
          this.qtyInput.value = item.quantity;
        }
        let formData = {
          items: [
            {
              id: item.variant_id,
              quantity: this.qtyInput.value,
              properties: {
                _preorder: true,
                preorder_qty: item.quantity,
              },
            },
          ],
        };
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }).then((response) => {
          if (response.ok) {
            window.location.href = "/cart";
          }
        });
      });
    }
  };

  init = () => {
    this.preOrderDetails();
    this.preOrderPopUp();
    this.addPreorder();
  };
}
if (document.querySelector(".template-product")) {
  let preOrderObj = new Preorder();
  simply.variantChangeEvent = (variant) => {
    preOrderObj.variantChange(variant);
  };
}
simply.getPreorderdetails = function (products, model) {
  if (products) {
    let preOrderObj = new Preorder(products, model);
    simply.variantChangeEvent = (variant) => {
      preOrderObj.variantChange(variant);
    };
  }
};

class Cart {
  constructor() {
    this.cartJson = simply.cartItems;
    this.init();
  }
  cartItemQty = () => {
    let items = this.cartJson.items;
    let cartItems = document.querySelectorAll(".cartitems--list .cart-item");
    let lineValue = 0
    items.map((item, key) => {
      console.log("key", key + 1);
      lineValue = key + 1;
      if (item.properties._preorder) {
        cartItems.forEach(list => {
          if (list.getAttribute('data-cartitem-id') == item.id) {
            let input = list.querySelector(".form-field-input.form-field-number");
            if (input.value > item.properties.preorder_qty) {
              let formData = {
                quantity: item.properties.preorder_qty,
                id: item.key
              };
              fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              }).then(response => {
                if (response.ok) {
                  location.reload();
                }
              })
            }
            input.addEventListener("input", (e) => {
              if (input.value > item.properties.preorder_qty) {
                input.value = item.properties.preorder_qty;
              }
            })
          }
        })
      }
    })
  }
  clickEvent = () => {
    let checkboxValidation = document.querySelectorAll('.cart-form');
    let zooomytermscheck = document.querySelector('#zooomytermscheck');
    let zooomytermscheck_two = document.querySelector('#zooomytermscheck-two');
    if (checkboxValidation) {
      checkboxValidation.forEach(item => {
        item.addEventListener('submit', (e) => {

          // this.cartItemQty();
          if (zooomytermscheck && zooomytermscheck_two) {
            if (!zooomytermscheck.checked || !zooomytermscheck_two.checked) {
              e.preventDefault();
              if (!zooomytermscheck.checked && !zooomytermscheck_two.checked) {
                alert('Please check both checkboxes for shipping policies, Guarantee and Refund Policy');
              } else if (!zooomytermscheck.checked) {
                alert('Please check the checkbox for shipping policies.');
              } else if (!zooomytermscheck_two.checked) {
                alert('Please check the checkbox for Guarantee and Refund Policy');
              }

              return;
            }
          }
        })
      });
    }
  }

  init = () => {
    this.clickEvent();
  }
}
if (document.querySelector(".template-cart")) {
  new Cart;
}
window.addEventListener('load', function () {
  if (location.href.includes('shipping-policy')) {
    qs('.page-title').style.display = 'none';
    qs('.site-page').classList.add('page__container');
    qs('.page-content.rte').classList.remove('page-content');
  }
});